import React from "react";
import { CGE } from "../../../../common/components/CGE";
import "../../styles/index.scss";

const ItemAgreement = ({ label, value, description }) => {

    return (
        <>
            <div className="col-md-12 border-top border-bottom d-flex py-2 resp-pl-0 ">
                <div className="col-md-6 resp-pl-0 ">
                    <CGE.Text size="4" text={label} />

                </div>
                <div className="col-md-6 text-right">
                    <CGE.Text size="4" text={value} />
                </div>
            </div>
            {description &&
                <div className="col-md-12 resp-pl-0 text-center">
                    <CGE.Text size="2" text={description} />
                </div>
            }
        </>
    );
};

export default ItemAgreement;